import css from 'styled-jsx/css';
import { colorPalette, pageWidth } from 'styles/css-constants';
import { MQ_LARGE, MQ_MEDIUM, MQ_SMALL_ONLY } from 'constants/mq';

/*
Overview
--------
*/
export default css`
  .Spread__item--profile,
  .Spread__item--teaser,
  .Spread__item--teaserCard {
    margin-bottom: 1.5rem;
  }

  .Spread__item--profile:last-child,
  .Spread__item--teaser:last-child,
  .Spread__item--teaserCard:last-child,
  .Spread__item--teaserFlipCard:last-child {
    margin-bottom: 0;
  }

  .Spread__items {
    padding: 0 1rem;
  }

  .Spread__title {
    margin: 0 1rem;
    border-top: 2px solid ${colorPalette.gray};
    border-bottom: none;
    padding: 1rem 0;
  }

  .Spread__title h4 {
    color: $gray--darker;
    font-size: var(--fontScaleNeg1);
    font-weight: normal;
    text-align: center;

    font-size: 18px;
  }

  @media (min-width: 48rem) {
    .Spread__item--ad {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .Spread__item--profile,
    .Spread__item--teaser {
      flex: 0 0 33.33%;
      margin-bottom: 1.5rem;
      max-width: 33.33%;
      padding: 0 0.75rem;
    }

    .Spread__items {
      padding: 0;
    }

    .Spread__title {
      margin: 0;
    }
  }

  @media ${MQ_SMALL_ONLY} {
    .Spread__items {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .Spread__item--teaserFlipCard {
      margin-bottom: 1.5rem;
      flex: 0 0 50%;
      max-width: 50%;
    }

    .Spread__item--teaserFlipCard:nth-child(even) {
      padding-left: 0.375rem;
    }

    .Spread__item--teaserFlipCard:nth-child(odd) {
      padding-right: 0.375rem;
    }
  }

  @media ${MQ_LARGE} {
    .Spread--nestedGrid {
      grid-template:
        'title'
        'description'
        'items' /
        1fr;
    }

    .Spread__items {
      width: ${pageWidth.large};
      margin: 0 auto;
      padding: 0;
    }

    .Spread__title h4 {
      font-size: var(--fontScale1);
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) {
      .Spread__item--ad {
        grid-column: span 3;
      }

      .Spread__item--profile,
      .Spread__item--teaser {
        margin-bottom: 0;
        max-width: none;
        padding: 0;
      }

      .Spread__items {
        margin: 0;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 1.5rem;
        grid-row-gap: 2.25rem;
        width: 100%;
      }
    }
  }

  /* Search page grid */
  :global(main[data-page-path='/search']) .Spread__item--teaserCard {
    margin-bottom: 1rem;
  }

  @media screen and ${MQ_MEDIUM} {
    :global(main[data-page-path='/search']) .Spread--nestedGrid {
      margin-bottom: 1.5rem;
    }

    :global(main[data-page-path='/search']) .Spread__item--teaserCard {
      margin-bottom: 0;
    }

    :global(main[data-page-path='/search']) .Spread__items {
      grid-row-gap: 1.5rem;
    }
  }
`;
